import { RouterModule, Routes } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { GamificationContainerComponent } from './gamification-container.component';
import { GamificationHeaderComponent } from './header/gamification-header.component';
import { GamificationProfileComponent } from './profile/gamification-profile.component';
import { GamificationMetricsComponent } from './metrics/gamification-metrics.component';
import { GamificationBadgesComponent } from './badges/gamification-badges.component';
import { BadgeProgressCircleComponent } from './badge-progress-circle/badge-progress-circle.component';
import { BadgeProgressSmallCircleComponent } from './badge-progress-small-circle/badge-progress-small-circle.component';

const routes: Routes = [
  { path: '', component: GamificationContainerComponent, data: { title: 'Supplier Metrics' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GamificationRoutingModule {}

@NgModule({
  imports: [
    GamificationRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [
    GamificationContainerComponent,
    GamificationHeaderComponent,
    GamificationProfileComponent,
    GamificationMetricsComponent,
    GamificationBadgesComponent,
    BadgeProgressCircleComponent,
    BadgeProgressSmallCircleComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GamificationModule {}
